export const APP_NAME = "Sum1 Investments";
export const PERSIST_STORE_NAME = "admin";
export const REDIRECT_URL_KEY = "redirectUrl";
export const SUM1_DEFAULT_ABOUT = "Sum1 Investments is a community-based investment platform founded in 2020 that enables stokvels to invest in small businesses, targeting annual returns of 15-20%."
